import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useIntl } from 'react-intl';
import { NavItem } from '../../../components/layout/sidenav/link/NavItem';
export function ContentAiLinks() {
  const { $t } = useIntl();

  return (
    <NavItem to="/content-ai" icon={<AutoFixHighIcon />}>
      {$t({
        id: 'contentAi.title',
        defaultMessage: 'Content AI',
      })}
    </NavItem>
  );
}
